.exclamation-icon{color:#ffa71d}
/*# sourceMappingURL=help-tooltip.component.css.map */
